import { JSQ_PHONE, JSQ_STAFF_SUPPORT_EMAIL } from "./copy";

export const STATUS_COMPLETED = "COMPLETED";
export const STATUS_FAILED = "ERROR";
export const STATUS_QUEUED = "QUEUED";
export const STATUS_RUNNING = "RUNNING";
export const JOB_POLLING_INTERVAL = 1000;
export const getCriticalErrorMsg = (supportPhone?: string, supportEmail?: string): string => {
  return `A critical error has occurred. Please contact support at ${
    supportPhone || JSQ_PHONE
  } or ${supportEmail || JSQ_STAFF_SUPPORT_EMAIL}`;
};
